// src/lib/flags.ts
// IMPORTANT: Requires a configured SMTP provider in production.
// Supabase free tier built-in email is rate-limited to 2/hour and is for testing only.
// Configure custom SMTP in Supabase Dashboard → Project Settings → Auth → SMTP Settings
// Recommended: Resend (resend.com) — free tier = 3 000 emails/month
//   Host: smtp.resend.com | Port: 465 | Username: resend | Password: <Resend API key>
//   Sender: noreply@indiestryvoice.com
export const REQUIRE_EMAIL_VERIFICATION = true;

// Other feature flags
// Google Auth is the second supported sign-in method. Default ON; set
// ENABLE_GOOGLE_AUTH=false in env to hide the buttons (e.g. if Google
// provider config in the Supabase dashboard breaks and we want to fall
// back to password-only fast).
export const ENABLE_GOOGLE_AUTH = process.env.ENABLE_GOOGLE_AUTH !== 'false';
export const ENABLE_DEBUG_MODE = process.env.NODE_ENV === 'development';

// Two-theme system (Booth dark / Daylight light) toggle. Default OFF: the
// topbar toggle is hidden and the site is forced to Booth regardless of any
// stored preference. ON: the toggle shows and Booth ⇄ Daylight is a persisted
// per-user preference. Booth is a near-identical evolution of the current
// palette (safe as the universal default); Daylight stays gated until the rest
// of the site is themed. Same file-const flag pattern as SHOW_MANAGE_JOBS.
export const THEME_TOGGLE = true;

// Poster-side applicant review (/jobs/manage + its child routes, the "Manage
// Jobs" nav dropdown entry, and the unreviewed-applicant badge). The whole
// surface is built and ownership-scoped (RLS + authorizePosterForApplication);
// this single flag gates its visibility. Previously duplicated as a file-local
// const in src/app/jobs/manage/page.tsx and src/components/NavbarAuth.tsx —
// unified here so the two can't drift.
export const SHOW_MANAGE_JOBS = true;

// Workshops promoted-placement checkout. OFF at launch — posting is free, the
// PaymentScreen ships DORMANT and is NOT part of the publish flow (publish goes
// straight to in_review). Flip to true later to activate paid placements with
// no redesign. (README §7 `workshops.paidPlacements`.)
export const WORKSHOPS_PAID_PLACEMENTS = process.env.WORKSHOPS_PAID_PLACEMENTS === 'true';

// Legacy exports for backward compatibility
export const googleAuthEnabled = ENABLE_GOOGLE_AUTH;
export const CONFIRM_EMAILS = REQUIRE_EMAIL_VERIFICATION;

// Helper functions
export const isEmailVerificationRequired = () => REQUIRE_EMAIL_VERIFICATION;
export const isTestingMode = () => !REQUIRE_EMAIL_VERIFICATION; 